import React from 'react';
import PropTypes from 'prop-types';
import { ICON_TYPES } from './constants';

const Preview = ({ icon }) => {
  if (!icon) {
    return (
      <div className="select-icon__preview-empty">
        <div className="select-icon__preview-icon">
          <span className="fas fa-smile" />
        </div>
        <div className="select-icon__preview-description">Add icon</div>
      </div>
    )
  }
  switch (icon.icon_type) {
  case ICON_TYPES.IMAGE:
    return (
      <div className="select-icon__preview-image">
        <img src={icon.url} alt="Icon" />
      </div>
    )
  case ICON_TYPES.EMOJI:
    return (
      <div className="select-icon__preview-emoji">
        {icon.icon}
      </div>
    )
  case ICON_TYPES.ICON:
    return (
      <div className="select-icon__preview-icons">
        <span className={icon.icon} />
      </div>
    )
  default:
    return null;
  }
}

Preview.propTypes = {
  icon: PropTypes.object,
};
export default Preview;
